import { render } from "./DataPrint.vue?vue&type=template&id=66acf81b"
import script from "./DataPrint.vue?vue&type=script&lang=js"
export * from "./DataPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__